var _defs, _title, _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 19",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "menu")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,0h22A1.5,1.5,0,0,1,25,1.5h0A1.5,1.5,0,0,1,23.5,3H1.5A1.5,1.5,0,0,1,0,1.5H0A1.5,1.5,0,0,1,1.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,8h22A1.5,1.5,0,0,1,25,9.5h0A1.5,1.5,0,0,1,23.5,11H1.5A1.5,1.5,0,0,1,0,9.5H0A1.5,1.5,0,0,1,1.5,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,16h22A1.5,1.5,0,0,1,25,17.5h0A1.5,1.5,0,0,1,23.5,19H1.5A1.5,1.5,0,0,1,0,17.5H0A1.5,1.5,0,0,1,1.5,16Z"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.0b9cc905.svg";
export { ForwardRef as ReactComponent };